import * as R from 'ramda'
import { createContext, useContextSelector } from 'use-context-selector'

import { NOOP } from 'constants/commonConstans'

import type { CourseValueType, ICourseOption } from '../CourseKitTypes'

export interface IMenuContext<V extends CourseValueType> {
  value?: V
  hovered: ICourseOption<V> | null
  setHovered: React.Dispatch<React.SetStateAction<ICourseOption<V> | null>>
}

const MenuContext = createContext<IMenuContext<CourseValueType>>({
  value: null,
  hovered: null,
  setHovered: NOOP,
})

export const useSetHovered = () => useContextSelector(MenuContext, (c) => c.setHovered)
export const useMenuItemIsHovered = <V>(value: V) =>
  useContextSelector(MenuContext, (c) => c.hovered && c.hovered?.value === value)
export const useMenuItemIsSelected = <V>(value: V) =>
  useContextSelector(MenuContext, (c) =>
    c.value && Array.isArray(c.value)
      ? !R.isNil(value) && c.value.includes(value)
      : c.value === value,
  )

export default MenuContext
